module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 21.5c-3.5 0-6.3-3.1-6.3-7.1 0-4 5.6-10.7 5.9-11L18 3l.4.5c.2.3 5.9 7 5.9 11 0 3.9-2.8 7-6.3 7zm0-16.9c-1.3 1.6-5.3 6.8-5.3 9.9 0 3.5 2.3 6.1 5.3 6.1s5.3-2.6 5.3-6.1c0-3.1-4-8.3-5.3-9.9z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tool_color.svg
// module id = 722
// module chunks = 2